import { UploadItem } from "@presentation/stores/UploadStore";

const UPLOAD_STATUS_COLORS: Record<UploadItem["status"], string> = {
  completed: "green",
  failed: "red",
  cancelled: "#666",
  interrupted: "#666",
  uploading: "inherit",
  pending: "inherit",
};

const UPLOAD_STATUS_LABELS: Partial<Record<UploadItem["status"], string>> = {
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
};

export const getUploadStatusColor = (status: UploadItem["status"]): string => UPLOAD_STATUS_COLORS[status];

export const getUploadStatusLabel = (upload: Pick<UploadItem, "status" | "progress">): string => UPLOAD_STATUS_LABELS[upload.status] ?? `${Math.round(upload.progress.percent)}%`;

/**
Full destination shown to the user - just the subfolder is ambiguous once a project has 2+ configured
roots for a facet, so the chosen root (when known) is shown alongside it.
*/
export const formatUploadDestination = (rootPath: string | null | undefined, folder: string | null | undefined): string => {
  const trimmedRoot = (rootPath ?? "").replaceAll("\\", "/").replaceAll(/^\/+|\/+$/g, "");
  const trimmedFolder = (folder ?? "").replaceAll("\\", "/").replaceAll(/^\/+|\/+$/g, "");
  return [trimmedRoot, trimmedFolder].filter(Boolean).join("/") || "Root";
};
